import model from '../Apis/Edu_programs'
import Controller from './Controller'

export default class EduProgramsController extends Controller {
  constructor() {
    super(new model())
  }
  programType() {
    return ['systematic', 'non_systematic', 'non_arabic', 'women', 'children', 'bhd', 'quran']
  }
  async MyEduPrograms() {
    try {
      const data = await this.model.MyEduPrograms()
      return data
    } catch (error) {
      console.error(error)
      return error
    }
  }
  async Details(id, params) {
    try {
      const response = await this.model.Details(id, params);
      return response;
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async SubscribebyCode(params) {
    try {
      const data = await this.model.SubscribebyCode(params)
      return data
    } catch (error) {
      console.error(error)
      return error
    }
  }
  async UnSubscribed(params) {
    try {
      const data = await this.model.UnSubscribed(params)
      return data
    } catch (error) {
      console.error(error)
      return error
    }
  }
  async getCurrentEvents(id) {
    const response = await this.model.getCurrentEvents(id)
    return response
  }

  async Home() {
    const data = {}
    let eduProgramId = localStorage.getItem("eduProgram")
    data.eduProgram = await this.Show(eduProgramId)
    return data
  }
  async getFAQ() {
    let eduProgramId = localStorage.getItem("eduProgram")
    const data = await this.model.getFAQ(eduProgramId)
    return data
  }
  async subscribe(id) {
    const data = await this.model.subscribe(id)
    return data
  }
  async subscribionFree(id) {
    const data = await this.model.subscribionFree(id)
    return data
  }
  async getCourseByProgram(id, getAll = false) {
    let eduProgramId = localStorage.getItem("eduProgram")
    if (id) eduProgramId = id;


    const response = await this.model.getCourseByProgram(eduProgramId);
    if (getAll) {
      return response
    }
    return response.courses;
  }
  async getCourseByProgramTeacher(id,getAll = false){
    let eduProgramId = localStorage.getItem("eduProgram")
    if (id) eduProgramId = id;


    const response = await this.model.getCourseByProgramTeacher(eduProgramId);
    if (getAll) {
      return response
    }
    return response.courses;
  }
  async GetAllCourses() {
    const response = await this.model.GetAllCourses();
    return response.courses;
  }
    async getExcelByProgram(id, getAll = false) {
    let eduProgramId = localStorage.getItem("eduProgram")
    if (id) eduProgramId = id;

    const response = await this.model.getExcelByProgram(eduProgramId);
    if (getAll) {
      return response
    }
    return response.courses;
  }
  async GetUsers(eduProgramId) {

    const response = await this.model.GetUsers(eduProgramId);
    return response;
  }
  async GetTeachersCourses(eduProgramId) {

    const response = await this.model.GetTeachersCourses(eduProgramId);
    return response;
  }
  async AssignOfficialExams(eduProgramId) {

    const response = await this.model.AssignOfficialExams(eduProgramId);
    return response;
  }


  async saveOfficialExams(edu_program, data) {
    const res = await this.model.saveOfficialExams(edu_program, data);
    return this.Poup(res);
  }

  async SaveCourses(edu_program, data) {
    const res = await this.model.SaveCourses(edu_program, data);
    return this.Poup(res);
  }
  async AddEduProgramDetails(data) {
    const res = await this.model.AddEduProgramDetails(data);
    return this.Poup(res);
  }
  async SaveTeachers(id, data, headers = {}) {
    const response = await this.model.SaveTeachers(id, data, headers = {})
    return this.Poup(response);
  }


  async EduProgramApproval(data) {
    const response = await this.model.EduProgramApproval(data)
    return this.Poup(response);

  }

  async getSemsterId(id) {
    const response = await this.model.getSemsterId(id)
    return response;
  }

  async getEduCoursesOfFailedRoomsUsers(id) {
    const  response  = await this.model.getEduCoursesOfFailedRoomsUsers(id);
    return response;
  }

}
